<template>
  <HKLTabs
    class="green-fitout green-fitout-sub-tabs shadowline-theme"
    @change="tabPaneChange"
  >
    <a-tab-pane
      v-if="shouldShowForTenant || isHKlandUser"
      key="1"
      :tab="$t('tenantProjects.comments')"
    >
      <GreenFitOutComments class="green-fitout__body" />
    </a-tab-pane>
    <a-tab-pane
      key="2"
      :tab="$t('tenantProjects.guideline')"
    >
      <PostFitOutGuideline
        class="green-fitout__body guidelines"
        :guidelines="publishedGuideLines"
      />
    </a-tab-pane>
  </HKLTabs>
</template>

<script>
import { getGuidelines } from '@/api/settings/request'
import HKLTabs from '@/controls/Tab/HKLTabs'
import { useProvidedTabActiveKey } from '@/controls/Tab/hook'
import { GUIDELINE_TYPE } from '@/modules/settings/engineers/consts'
import { useStoreGetters } from '@/store/index'
import { GUIDELINE_STATUS } from '@/utils/locale'
import { computed, onBeforeMount, reactive, toRefs } from 'vue-demi'
import PostFitOutGuideline from '../postFitOutLetter/PostFitOutGuideline'
import GreenFitOutComments from './GreenFitOutComments'
import {
  GREEN_INJECTION_KEYS,
  GREEN_FITOUT_SUB_TAB_MAP,
} from './consts'
import { useCurrentGreenFitoutStatus } from './hook'
import { sortGuidelines } from './utils'

export default {
  components: {
    HKLTabs,
    GreenFitOutComments,
    PostFitOutGuideline,
  },
  setup () {
    const { isTenant, isHKlandUser } = useStoreGetters('user', ['isTenant', 'isHKlandUser'])
    // @TODO It should reuse because it is same as `GreenFitOutGuidelineSelector`
    const { isUnderReview, isCompleted } = useCurrentGreenFitoutStatus()
    const setupData = reactive({
      isUnderReview,
      isCompleted,
      publishedGuideLines: [],
    })
    onBeforeMount(async () => {
      const result = await getGuidelines(GUIDELINE_STATUS.PUBLISHED, GUIDELINE_TYPE.GREEN_FITOUT)
      setupData.publishedGuideLines = sortGuidelines(result.guidelines) || []
    })
    const { tabPaneChange } = useProvidedTabActiveKey(GREEN_INJECTION_KEYS.ACTIVE_SUB_TAB, GREEN_FITOUT_SUB_TAB_MAP)
    return {
      ...toRefs(setupData),
      tabPaneChange,
      isHKlandUser,
      shouldShowForTenant: computed(() => {
        return isTenant.value && (isUnderReview.value || isCompleted.value)
      }),
    }
  },
}
</script>
<style lang="scss" scoped>
@import "./style.scss";
.green-fitout-sub-tabs.shadowline-theme {
  ::v-deep {
    .ant-tabs-tab {
      height: 48px;
      line-height: 48px;
    }
  }
}
</style>
